import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { NotificationList, NotificationResponse, NotificationSearch } from './apiTypes';

export const dashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/dashoard",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getAllNotification: builder.query<NotificationList, NotificationSearch>({
            query: (query) => `get-all-notification?type=${query.type || ""}&page=${query.page || 0}&size=${query.size || 10}&properties=modifiedDate&sortBy=DESC`,
            transformResponse: (response: { body: NotificationList }, meta, arg) => {
                return response.body;
            },
        }),
        countNotificationNotRead: builder.query<number, {}>({
            query: () => `count-notification-not-read`,
            transformResponse: (response: { body: number }, meta, arg) => {
                return response.body;
            },
        }),
        readNotification: builder.query<NotificationResponse, number>({
            query: (id) => `read-notification/${id}`,
            transformResponse: (response: { body: NotificationResponse }, meta, arg) => {
                return response.body;
            }
        })
    })
})
export default dashboardApi;

export const {
    useLazyGetAllNotificationQuery,
    useLazyCountNotificationNotReadQuery,
    useLazyReadNotificationQuery
} = dashboardApi;
